//@flow

import type {CreateMultichatFunnelStage} from '../../../entities';

export const DEFAULT_MULTICHAT_FUNNELS_STAGES: CreateMultichatFunnelStage[] = [
  {
    color: '#3B82F6',
    label: 'Contacto Inicial',
  },
  {
    color: '#F97316',
    label: 'En conversación',
  },
  {
    color: '#10B981',
    label: 'Pedido Generado',
  },
  {
    color: '#84CC16',
    label: 'Orden Pagada',
  },
  {
    color: '#EC4899',
    label: 'Orden Entregada',
  },
];

export const MULTICHAT_FUNNEL_COLORS = [
  '#F59E0B',
  '#F97316',
  '#DC2626',
  '#EC4899',
  '#C026D3',
  '#7C3AED',
  '#1D4ED8',
  '#3B82F6',
  '#38BDF8',
  '#10B981',
  '#84CC16',
  '#475569',
];
